interface LoadingParams {
  text?: string;
  className?: string;
}

// A "full page" loading indicator
// FIXME: this should maybe not be a component, but an atom or a molecule instead
export const Loading = ({ text, className }: LoadingParams) => {
  return (
    <div
      className={`flex h-screen items-center justify-center bg-white ${className}`}
    >
      <div
        role="progressbar"
        className="font-bold"
        data-testid="page-loading-indicator"
      >
        {text || 'Loading...'}
      </div>
    </div>
  );
};
